(function () {

  'use strict';

  angular.module('SoftwareProvider', [])

    .constant('UpdateStrategy', {
      ADVANCE: 'ADVANCE',
      GENERAL: 'GENERAL',
      SPECIFIC: 'SPECIFIC',
      DISABLED: 'DISABLED'
    })

    .constant('ApplicationType', {
      CLIENT: 'CLIENT',
      REDIRECTOR: 'REDIRECTOR',
      CONFIGURATOR: 'CONFIGURATOR'
    })

    .constant('OperatingSystem', {
      MAC: 'MAC',
      WIN: 'WIN'
    })

    .constant('FileType', {
      DMG: 'DMG',
      EXE: 'EXE',
      MSI: 'MSI',
      PKG: 'PKG',
      ZIP: 'ZIP'
    })

    .constant('CpuArchitecture', {
      X86: 'x86',
      X64: 'x64',
      ARM64: 'arm64'
    })

    .factory('PrintixVersion', function () {
      return function (versionString) {
        const printixVersion = {
          fromString: function (versionString) {
            const splitVersion = versionString.split('.');
            this.year = +splitVersion[0];
            this.quarter = +splitVersion[1];
            this.reserved = +splitVersion[2];
            this.build = +splitVersion[3];
          },

          toString: function () {
            return `${this.year}.${this.quarter}.${this.reserved}.${this.build}`;
          },

          compareTo: function (otherVersion) {
            if (this.year < otherVersion.year) {
              return -1;
            } else if (this.year > otherVersion.year) {
              return 1;
            }
            if (this.quarter < otherVersion.quarter) {
              return -1;
            } else if (this.quarter > otherVersion.quarter) {
              return 1;
            }
            if (this.reserved < otherVersion.reserved) {
              return -1;
            } else if (this.reserved > otherVersion.reserved) {
              return 1;
            }
            if (this.build < otherVersion.build) {
              return -1;
            } else if (this.build > otherVersion.build) {
              return 1;
            }
            return 0;
          }
        };
        if (versionString) {
          printixVersion.fromString(versionString);
        }
        return printixVersion;
      };
    })

    // .factory('ApplicationFile', function () {
    //   return function () {
    //     return {
    //       type: '',     // FileType
    //       cpuArch: '',  // CpuArchitecture
    //       path: ''      // string
    //     };
    //   };
    // })

    // .factory('VersionsOfDesktopApplications', function () {
    //   return function () {
    //     return {
    //       updateStrategy: '',      // UpdateStrategy
    //       applications: [          // always contains 4 items
    //         {
    //           appType: '',         // ApplicationType
    //           os: '',              // OperatingSystem
    //           availableVersions: [
    //             {
    //               version: '',     // PrintixVersion
    //               files: []        // Array of ApplicationFile
    //             }
    //           ],
    //           generalVersion: '',  // PrintixVersion
    //           advanceVersion: '',  // PrintixVersion
    //           customVersion: '',   // PrintixVersion
    //           specificVersion: {
    //             version: '',       // PrintixVersion
    //             files: []          // Array of ApplicationFile
    //           }
    //         }
    //       ]
    //     };
    //   };
    // })

    // .factory('UpdateStrategyOfDesktopApplications', function () {
    //   return function () {
    //     return {
    //       updateStrategy: '',  // UpdateStrategy
    //       specificVersions: [  // contains 4 items
    //         {
    //           appType: '',     // ApplicationType
    //           os: '',          // OperatingSystem
    //           version: '',     // PrintixVersion
    //           files: []        // Array of ApplicationFile
    //         }
    //       ]
    //     };
    //   };
    // })

    .service('SoftwareService', function ($http, $q, TenantListService) {

      this.getVersionsOfDesktopApplications = function () {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links['px:software'].href.replace('/v1/', '/v1/admin/');
        $http.get(url + '/desktop/all')
          .then(function (response) {
            deferred.resolve(response.data);
          })
          .catch(function (response) {
            deferred.reject(response.data);
          });
        return deferred.promise;
      };

      this.setUpdateStrategyOfDesktopApplications = function (updateStrategy) {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links['px:software'].href.replace('/v1/', '/v1/admin/');
        $http.post(url + '/desktop/autoupdate', updateStrategy)
          .then(function (response) {
            deferred.resolve();
          })
          .catch(function (response) {
            deferred.reject(response.data);
          });
        return deferred.promise;
      };

      this.forcePrintixClientVersionOnWorkstation = function (workstationId, version) {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links['px:software'].href.replace('/v1/', '/v1/admin/');
        const data = { workstationId, version };
        $http.post(url + '/desktop/forceupdate', data)
          .then(function (response) {
            deferred.resolve();
          })
          .catch(function (response) {
            deferred.reject(response.data);
          });
        return deferred.promise;
      };

      this.getConfiguredSoftwareVersion = function (applicationType, operatingSystem, cpuArchitecture, fileType) {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links['px:software'].href;
        const params = { appl: applicationType, os: operatingSystem, cpuArch: cpuArchitecture, type: fileType };
        $http.get(url, { params })
          .then(function (response) {
            deferred.resolve(response.data);
          })
          .catch(function (response) {
            deferred.reject(response.data);
          });
        return deferred.promise;
      };

      this.buildDesktopApplicationDownloadUrl = function (applicationType, operatingSystem, cpuArchitecture, fileType, version) {
        let url = TenantListService.currentTenant.info._links['px:software'].href +
          '/appl/' + applicationType + '/os/' + operatingSystem + '/type/' + fileType;
        const queryParams = [];
        if (cpuArchitecture) {
          queryParams.push('cpuArch=' + cpuArchitecture);
        }
        if (version) {
          queryParams.push('version=' + version);
        }
        if (queryParams.length) {
          url += '?' + queryParams.join('&');
        }
        return url;
      };

    });

})();
